import $api from "../http";
import { StripeSettings } from "../models/StripeSettings";
import { ISettings } from "../models/Settings";
import { IMaintenanceSettings } from "../models/MaintenanceSettings";

class SettingsServiceClass {
  async getStripeService() {
    return $api.get<StripeSettings>("api/stripe/settings");
  }

  async updateStripeSettings(model: Omit<StripeSettings, "id" | "apiVersion">) {
    return $api.put<boolean>("api/stripe/settings", model);
  }

  async getSettings() {
    return $api.get<ISettings>(`api/settings`);
  }

  async updateSettings(model: Omit<ISettings, "id">) {
    return $api.put<{}>("api/settings", model);
  }

  async getMaintenanceSettings() {
    return $api.get<IMaintenanceSettings>(`api/maintenance-settings`);
  }

  async updateMaintenanceSettings(model: Omit<IMaintenanceSettings, "id">) {
    return $api.put<{}>(`api/maintenance-settings`, model);
  }
}

export const SettingsService = new SettingsServiceClass();
